<template>
  <helper-layout :loaded="mx_loaded">
    <material-table
      :headers="headers"
      :items="alloactionsData.items"
      :paginate="paginateConfig"
      :search-data="searchData"
      :total-count="alloactionsData.totalCount"
      @pageChange="handlePageChange"
      @searchChange="handleSearchChange"
      @rowClick="handleRowClick"
    >
      <template v-slot:toolbar>
        <v-flex shrink style="text-align: right" class="toolbar">
          <!-- 导出当日出货一览 -->
          <v-btn v-if="$util.tool.hasPerm('OrderManager.AllocationList.CsvExport')" solid @click="exportShipment">
            {{ $t('Views.Order.exportShipmentLK') }}
          </v-btn>
          <!-- 导出CSV（弥生） -->
          <v-btn v-if="$util.tool.hasPerm('OrderManager.AllocationList.CsvExport')" solid @click="exportFileCsv">
            {{ $t('Views.Order.exportCsv') }}
          </v-btn>
          <!-- 导出CSV（Smile） -->
          <v-btn v-if="$util.tool.hasPerm('OrderManager.AllocationList.CsvExport')" solid @click="exportFileCsvNew">
            {{ $t('Views.Order.exportCsvNew') }}
          </v-btn>
        </v-flex>
      </template>
    </material-table>

    <!-- 配货详情弹窗 -->
    <material-dialog :width="900" :visible="allocationDetailVisible" :show-sure="false" :cancle-text="$t('Views.Order.close')" :title="allocationTitle" @cancleFn="allocationDetailVisible = false">
      <template v-if="allocationDetail">
        <v-layout row wrap class="grid-container">
          <v-flex xs4 class="grid">
            <label class="label">{{ $t('Views.Order.distributeTime') }}</label>
            <span class="content">
              <span class="colon">:</span>
              <span class="value">{{ allocationDetail.stockTime | dateFmt }}</span>
            </span>
          </v-flex>
          <v-flex xs4 class="grid">
            <label class="label">{{ $t('Views.Order.shipmentDate') }}</label>
            <span class="content">
              <span class="colon">:</span>
              <span class="value">{{ allocationDetail.shipTime | dateFmt }}</span>
            </span>
          </v-flex>
          <v-flex xs4 class="grid">
            <label class="label">{{ $t('Views.Goods.status') }}</label>
            <span class="content">
              <span class="colon">:</span>
              <span class="value">{{ enums.ShipStatus[allocationDetail.status] }}</span>
            </span>
          </v-flex>
        </v-layout>
        <material-table :headers="deliveryHeaders" :items="allocationDetail.items" :has-paginate="false" />
      </template>
    </material-dialog>
  </helper-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { pageLoadMx } from '@/plugins/mixins'
import ENUMS from '@/dict/enums'
import { format } from 'date-fns'
import StatusList from './indexStatusList'

export default {
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      value1: '',
      enums: ENUMS,
      orderRowData: null,
      allocationDetail: null,
      allocationDetailVisible: false,
      orderIds: [], // 要导出的ID
      selectIds: [], // 页面选择的ID，只改变页面上复选框的状态
      cancelIds: [], // 页面取消勾选的ID
      deliveryHeaders: [
        {
          text: $t('Views.Order.index'),
          align: 'center',
          isSort: true
        },
        // 商品
        {
          text: $t('Views.Order.product'),
          value: 'product',
          render: (h, param) => {
            return h('material-img', {
              props: {
                desc: param.row.product && param.row.product.name,
                pictureKey: param.row.product.pictureKey,
                pictureWidth: 40,
                pictureHeight: 40,
                preview: true,
                serialNumber: param.row.product && param.row.product.yayoiSerialNumber,
                capacity: param.row.product && param.row.product.capacity
              }
            })
          }
        },
        // 批号
        {
          text: $t('Views.Order.rodNumber'),
          render: (h, param) => {
            const text = param.row.rodNumber ? param.row.rodNumber : ''
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        // 单价（税前）
        {
          text: $t('Views.Order.beforePrice'),
          align: 'right',
          render: (h, param) => {
            return h('ams-tooltips-num', {
              props: {
                orignPrice: param.row.price,
                otherPrice: param.row.targetCurrencyPrice,
                currencyName: this.orderRowData.currencyName
              }
            })
          }
        },
        // 订购数
        {
          text: $t('Views.Order.orderCount'),
          value: 'orderQuantity',
          sortable: false
        },
        // 配货数
        {
          text: $t('Views.Order.distributionNumber'),
          value: 'stockQuantity',
          sortable: false
        },
        // 配货小计（税前）
        {
          text: $t('Views.Order.beforeDistrbute'),
          render: (h, param) => {
            return h('ams-tooltips-num', {
              props: {
                orignPrice: param.row.totalPrice,
                otherPrice: param.row.targetCurrencyTotalPrice,
                currencyName: this.orderRowData.currencyName
              }
            })
          },
          align: 'right'
        }
      ],
      form: {
        isShowShippedOrder: true,
        sorting: '',
        skipCount: 0,
        maxResultCount: 10,
        shipTime: '',
        address: ''
      },
      items: [],
      paginateConfig: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      headers: [
        {
          // CSV出力可否
          renderHeader: (h, param) => {
            return h('div', {
              domProps: {
                innerHTML: $t('Views.Order.CSVOutput')
              }
            })
          },
          align: 'center',
          render: (h, param) => {
            return h('input', {
              domProps: {
                type: 'checkbox',
                checked: param.row.shipment == null ? false : !param.row.shipment.find((item) => item.status === 'ToBeShip')
                  ? false : param.row.isNotImported,
                disabled: param.row.shipment == null || !param.row.shipment.find((item) => item.status === 'ToBeShip')
              },
              on: {
                click: (p) => {
                  // 选择或取消选择要导出的ID
                  if (!this.orderIds.includes(param.row.orderId)) {
                    this.orderIds.push(param.row.orderId)
                  } else {
                    for (var i = 0; i < this.orderIds.length; i++) {
                      if (this.orderIds[i] === param.row.orderId) {
                        this.orderIds.splice(i, 1)
                      }
                    }
                  }
                  // 选择或取消选择改变页面状态的ID
                  if (!this.selectIds.includes(param.row.orderId)) {
                    this.selectIds.push(param.row.orderId)
                  } else {
                    for (var j = 0; j < this.selectIds.length; j++) {
                      if (this.selectIds[j] === param.row.orderId) {
                        this.selectIds.splice(j, 1)
                      }
                    }
                  }
                  // 取消勾选
                  if (param.row.isNotImported === true) {
                    if (!this.orderIds.includes(param.row.orderId) &&
                         this.selectIds.includes(param.row.orderId)) {
                      this.cancelIds.push(param.row.orderId)
                    }
                  } else { // 重新勾选
                    for (var k = 0; k < this.cancelIds.length; k++) {
                      if (this.cancelIds[k] === param.row.orderId) {
                        this.cancelIds.splice(k, 1)
                      }
                    }
                  }
                  param.row.isNotImported = p.path[0].checked
                }
              }
            },
            )
          }
        },
        {
          // 提前发货（暂定）
          renderHeader: (h, param) => {
            return h('div', {
              domProps: {
                innerHTML: $t('Views.Order.earlyShipment')
              }
            })
          },
          align: 'center',
          render: (h, param) => {
            return h('input', {
              domProps: {
                type: 'checkbox',
                checked: param.row.isEarlyShipment,
                disabled: true
              },
              class: 'isEarlyShipment'
            })
          }
        },
        {
          // 订单编号
          renderHeader: (h, param) => {
            return h('div', {
              domProps: {
                innerHTML: $t('Views.Order.orderNum') + '<br>' + $t('Views.Order.orderTime')
              }
            })
          },
          width: 120,
          align: 'left',
          render: (h, param) => {
            const text = param.row.orderNumber + '<br />' + format(param.row.orderTime, 'YYYY-MM-DD')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        // {
        //   // 客户名称
        //   text: $t('Views.Customer.customerInfo'),
        //   align: 'left',
        //   renderHeader: (h, params) => {
        //     return h('div', {
        //       domProps: {
        //         innerHTML: $t('Views.Order.clientName') + '<br/>' + $t('Views.Order.customerNum')
        //       }
        //     })
        //   },
        //   render: (h, param) => {
        //     const text = param.row.customer.name + (param.row.customer.serialNumber ? '<br />' + param.row.customer.serialNumber : '')
        //     return h('div', {
        //       domProps: {
        //         innerHTML: text
        //       }
        //     })
        //   },
        //   width: 180
        // },
        { // 客户名称 新客户编码
          text: $t('Views.Customer.customerInfo'),
          align: 'left',
          renderHeader: (h, params) => {
            return h('div', {
              domProps: {
                innerHTML: $t('Views.Order.clientName') + '<br/>' + $t('Views.Order.newCustomerNumList')
              }
            })
          },
          render: (h, param) => {
            const text = param.row.customer ? param.row.customer.name + (param.row.customer.newSerialNumber && param.row.customer.serialNumber ? '<br />' +
              param.row.customer.newSerialNumber : param.row.customer.newSerialNumber ? '<br />' + param.row.customer.newSerialNumber : '<br />' + param.row.customer.serialNumber) : '--'
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 180
        },
        // {
        //   // 收货人
        //   align: 'left',
        //   renderHeader: (h, params) => {
        //     return h('div', {
        //       domProps: {
        //         innerHTML: $t('Views.Order.receiver') + '<br/>' + $t('Views.Order.receiveNum')
        //       }
        //     })
        //   },
        //   render: (h, param) => {
        //     const text = param.row.receiverName + (param.row.receiverCode ? '<br />' + param.row.receiverCode : '<br />' + '--')
        //     return h('div', {
        //       domProps: {
        //         innerHTML: text
        //       }
        //     })
        //   },
        //   width: 180
        // },
        {
          // 新收货编码
          renderHeader: (h, params) => {
            return h('div', {
              domProps: {
                innerHTML: $t('Views.Order.receiver') + '<br/>' + $t('Views.Order.receiveCodeNum')
              }
            })
          },
          render: (h, param) => {
            const text = param.row.receiverName + (param.row.receiverNewCode && param.row.receiverCode ? '<br />' + param.row.receiverNewCode
              : param.row.receiverNewCode ? '<br />' + param.row.receiverNewCode : '<br />' + param.row.receiverCode)
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 180
        },
        {
          // 所属销售
          text: $t('Views.Finance.sales'),
          value: 'salesName',
          width: 120
        },
        {
          // 发货区分
          text: $t('Views.Order.allDiffrent'),
          value: 'isAutoAllocation',
          width: 90,
          render: (h, params) => {
            return h('label', params.row.isAutoAllocation === true ? $t('Views.Order.shipAll') : $t('Views.Order.shipPartial'))
          }
        },
        {
          // 支付状态
          text: $t('Views.Order.isDeposited'),
          value: 'orderState',
          render: (h, params) => {
            return h('label', {
              style: {
                color: params.row.orderState === 'Canceled' ? '#ABABAB' : params.row.orderState === 'PendingPayment' ? 'red' : 'black'
              }
            },
            params.row.orderState === 'PendingPayment' ? $t('Views.Order.pendingPayment') : $t('Views.Order.havePayment')
            )
          }
        },
        {
          // 配货编号
          text: $t('Views.Order.allNum'),
          value: 'shipmentNumbers',
          width: 140,
          render: (h, param) => {
            const self = this
            const { shipment } = param.row
            const childHtml = (() => {
              if (!shipment || shipment.length < 1) return '--'

              return shipment.map(item => {
                const textHtml = `${item.number}`
                return h(
                  'div',
                  {
                    class: 'allocation-num',
                    on: {
                      click() {
                        self.orderRowData = param.row
                        // 获取配货详情
                        self.getAllocationDetail(item.shipmentId).then(ret => {
                          self.allocationDetail = ret
                          self.allocationDetailVisible = true
                        })
                      }
                    }
                  },
                  textHtml
                )
              })
            })()
            return h('div', childHtml)
          }
        },
        {
          // 出货日
          text: $t('Views.Order.shipmentDate'),
          width: 110,
          align: 'left',
          render: (h, param) => {
            var html = ''
            if (param.row.shipment && param.row.shipment.length > 0) {
              param.row.shipment.forEach(item => {
                html += item.shipTime ? format(item.shipTime, 'YYYY-MM-DD') + '<br />' : '--' + '<br />'
              })
            } else {
              html = '--'
            }
            return h('div', {
              domProps: {
                innerHTML: html
              },
              style: {
                textAlign: 'left'
              }
            })
          }
        },
        {
          // 仓库名称
          text: $t('Views.Warehouse.warehouseName'),
          // value: 'warehouseName',
          width: 120,
          align: 'left',
          render: (h, param) => {
            var html = ''
            if (param.row.warehouseName) {
              html = param.row.warehouseName
            } else {
              html = '--'
            }
            return h('div', {
              domProps: {
                innerHTML: html
              },
              style: {
                textAlign: 'left'
              }
            })
          }
        },
        {
          // 配货时间
          text: $t('Views.Order.stockTime'),
          width: 150,
          align: 'left',
          render: (h, param) => {
            var html = ''
            if (param.row.shipment && param.row.shipment.length > 0) {
              param.row.shipment.forEach(item => {
                html += item.stockTime ? format(item.stockTime, 'YYYY-MM-DD HH:mm') + '<br />' : '--' + '<br />'
              })
            } else {
              html = '--'
            }
            return h('div', {
              domProps: {
                innerHTML: html
              },
              style: {
                textAlign: 'left'
              }
            })
          }
        },
        {
          // 发货日
          text: $t('Views.Order.ship_time_label'),
          width: 150,
          align: 'left',
          render: (h, param) => {
            var html = ''
            if (param.row.shipment && param.row.shipment.length > 0) {
              param.row.shipment.forEach(item => {
                html += item.shippedTime ? format(item.shippedTime, 'YYYY-MM-DD') + '<br />' : '--' + '<br />'
              })
            } else {
              html = '--'
            }
            return h('div', {
              domProps: {
                innerHTML: html
              },
              style: {
                textAlign: 'left'
              }
            })
          }
        },
        {// 送达日
          text: $t('Views.Order.shipDate'),
          width: 150,
          align: 'left',
          render: (h, param) => {
            var html = ''
            if (param.row.shipment && param.row.shipment.length > 0) {
              param.row.shipment.forEach(item => {
                html += item.shipDate ? format(item.shipDate, 'YYYY-MM-DD') + '<br />' : '--' + '<br />'
              })
            } else {
              html = '--'
            }
            return h('div', {
              domProps: {
                innerHTML: html
              },
              style: {
                textAlign: 'left'
              }
            })
          }
        },
        {// 送达时间
          text: $t('Views.Order.deliveryTime'),
          width: 150,
          align: 'left',
          render: (h, param) => {
            var html = ''
            if (param.row.shipment && param.row.shipment.length > 0) {
              param.row.shipment.forEach(item => {
                html += item.deliveryTime ? ENUMS.deliveryTime[item.deliveryTime] + '<br />' : '--' + '<br />'
              })
            } else {
              html = '--'
            }
            return h('div', {
              domProps: {
                innerHTML: html
              },
              style: {
                textAlign: 'left'
              }
            })
          }
        },
        {
          // 弥生记上
          text: $t('Views.Order.copyStatus'),
          value: 'copyStatus',
          width: 85,
          render: (h, param) => {
            return h(StatusList, {
              props: {
                shipments: param.row.shipment,
                type: 'yayoi'
              },
              on: {
                handleReloadList: () => {
                  this.getPage(this.paginateConfig.page)
                }
              }
            })
          }
        },
        {
          // 销售计上
          text: $t('Views.Order.salesCounted'),
          value: 'salesCounted',
          width: 85,
          render: (h, param) => {
            return h(StatusList, {
              props: {
                shipments: param.row.shipment,
                type: 'sale'
              },
              on: {
                handleReloadList: () => {
                  this.getPage(this.paginateConfig.page)
                }
              }
            })
          }
        },
        {
          // 配货状态
          text: $t('Views.Order.distributeStatus'),
          value: 'status',
          width: 100,
          render: (h, params) =>
            h(
              'div',
              {
                style: {
                  color: ENUMS.distrbuteType[params.row.status].color
                },
                class: 'status'
              },
              ENUMS.distrbuteType[params.row.status].text
            )
        },
        {
          // 操作
          text: $t('Views.Setting.action'),
          value: 'action',
          width: 110,
          actions: [
            {
              // 查看 param.row.status !== 'Pending' && this.$util.tool.hasPerm('OrderManager.AllocationList'),
              text: $t('Views.Order.view'),
              color: this.$store.state.app.color,
              // visible: true,
              visible: param => this.$util.tool.hasPerm('OrderManager.AllocationList') && param.row.canView === true,
              actionFn: param => {
                this.handleGoToDetail(param.row)
              }
            },
            {
              // 配货
              text: $t('Views.Order.distribution'),
              color: this.$store.state.app.payBtnColor,
              visible: param => (param.row.status === 'Pending' || param.row.status === 'Partial') && this.$util.tool.hasPerm('OrderManager.AllocationList.CreateShipment'),
              actionFn: param => {
                this.$router.push({
                  name: 'allocationDistribute',
                  query: {
                    id: param.row.orderId
                  }
                })
              }
            }
          ]
        }
      ],
      // 表格数据检索配置
      searchData: [
        {
          key: 'filter',
          value: '',
          label: $t('Views.Customer.customerInfo'),
          placeholder: $t('Views.Order.distributePlaceholder')
        },
        {
          key: 'salesId',
          type: 'select',
          name: $t('Views.Order.sale_label'),
          placeholder: $t('Core.System.pleaseSelect'),
          itemText: 'name',
          itemValue: 'id',
          state: [],
          value: ''
        },
        {
          key: 'daterange',
          type: 'daterange',
          icon: 'mdi-calendar-range',
          displayFormat: 'YYYY-MM-DD',
          label: $t('Views.Order.order_time_label'),
          value: {}
        },
        {
          key: 'productName',
          label: $t('Views.Order.goodsInfo'),
          placeholder: $t('Views.Order.search_goods_label'),
          value: ''
        },
        {
          key: 'orderNumber',
          label: $t('Views.Order.orderNum'),
          placeholder: $t('Views.Order.selectOrderNum'),
          value: ''
        },
        {
          key: 'currencyName',
          label: $t('Views.Order.settlementCurrency'),
          value: '',
          type: 'select',
          default: '',
          state: [
            {
              value: '',
              label: $t('Views.Order.allItem')
            },
            ...this.$util.tool.enumToSelect(ENUMS.currencyName)
          ]
        },
        {
          key: 'address',
          label: $t('Views.Order.allocationAddress'),
          value: '',
          default: '',
          type: 'select',
          state: [
            {
              value: '',
              label: $t('Views.Order.allItem')
            },
            ...this.$util.tool.enumToSelect(ENUMS.allocationAddressType)
          ]
        },
        {
          key: 'status',
          value: [],
          placeholder: $t('Core.System.total'),
          label: $t('Views.Order.distributeStatus'),
          type: 'select',
          multiple: true,
          default: [],
          state: [
            {
              value: 'Pending',
              label: $t('Views.Order.delivering')
            },
            {
              value: 'Partial',
              label: $t('Views.Order.deliveredPartial')
            },
            {
              value: 'Finished',
              label: $t('Views.Order.delivered')
            },
            {
              value: 'Canceld',
              label: $t('Views.Order.Cancel')
            }
          ]
        },
        {
          key: 'shipTime',
          type: 'date',
          icon: 'mdi-calendar-range',
          displayFormat: 'YYYY-MM-DD',
          label: $t('Views.Order.deliveryDeadline'),
          value: ''
        },
        {
          key: 'yayoiCounted',
          value: '',
          label: $t('Views.Order.copyStatus'),
          type: 'select',
          state: [
            {
              value: '',
              label: $t('Views.Order.allItem')
            },
            {
              value: true,
              label: $t('Views.Order.hasCopyed')
            },
            {
              value: false,
              label: $t('Views.Order.withoutCopyed')
            }
          ]
        },
        {
          key: 'salesCounted',
          value: '',
          label: $t('Views.Order.salesCounted'),
          type: 'select',
          state: [
            {
              value: '',
              label: $t('Views.Order.allItem')
            },
            {
              value: true,
              label: $t('Views.Order.hasCopyed')
            },
            {
              value: false,
              label: $t('Views.Order.withoutCopyed')
            }
          ]
        },
        {
          // 配货截止时间
          key: 'stockTime',
          type: 'datetimeinput',
          icon: 'mdi-calendar-range',
          displayFormat: 'YYYY-MM-DD HH:mm',
          label: $t('Views.Order.allocationDeadLine'),
          value: '',
          showDefaultTime: true
        },
        {// 发货日
          key: 'shipped',
          type: 'daterange',
          icon: 'mdi-calendar-range',
          displayFormat: 'YYYY-MM-DD',
          label: $t('Views.Order.ship_time_label'),
          value: {}
        },
        {// 送达日
          key: 'shipDate',
          type: 'date',
          icon: 'mdi-calendar-range',
          displayFormat: 'YYYY-MM-DD',
          label: $t('Views.Order.shipDate'),
          value: ''
        },
        {// 送达时间
          key: 'deliveryTime',
          label: $t('Views.Order.deliveryTime'),
          value: '',
          type: 'select',
          state: [
            {
              value: '',
              label: $t('Views.Order.allItem')
            },
            ...this.$util.tool.enumToSelect(ENUMS.deliveryTime)
          ]
        },
        {// 是否输出CSV
          key: 'isNotImported',
          label: $t('Views.Order.CSVOutputCheck'),
          value: '',
          type: 'select',
          state: [
            {
              value: '',
              label: $t('Views.Order.allItem')
            },
            ...this.$util.tool.enumToSelect(ENUMS.CSVOutput)
          ]
        },
        {
          key: 'warehouseId',
          value: '',
          type: 'select',
          name: $t('Views.Warehouse.warehouseName'),
          placeholder: $t('Core.System.pleaseSelect'),
          itemText: 'name',
          itemValue: 'id',
          state: []
        },
        {// 查看出货订单
          key: 'isShowShippedOrder',
          label: $t('Views.Order.viewOrderSearch'),
          value: true,
          type: 'checkbox'
        }
      ]
    }
  },
  computed: {
    ...mapState('warehouse', ['warehouseList']),
    ...mapState('order', ['alloactionsData', 'allocationSearch']),
    ...mapState('setting', ['staffAllData']),
    ...mapState('login', ['userInfo']),
    allocationTitle() {
      if (!this.allocationDetail) return ''
      return this.$t('Views.Order.allocateNumb') + ': ' + this.allocationDetail.stockNumber
    }
  },
  mounted() {
    if (this.$route.query.isFromDashboard) {
      this.form.salesId = this.userInfo && this.userInfo.isSales ? this.userInfo.staffId : ''
      this.searchData[1].value = this.userInfo && this.userInfo.isSales ? this.userInfo.staffId : '' // 所属销售
      this.searchData[7].value = ['Pending', 'Partial'] // 配货状态
      this.form.status = ['Pending', 'Partial']
      this.form.isFromDashboard = this.$route.query.isFromDashboard
      this.searchData[this.searchData.length - 1].value = false
      this.form.isShowShippedOrder = false
    } else {
      // 读取store里面的搜索条件
      if (this.allocationSearch && this.allocationSearch.searchData && this.form) {
        this.searchData = JSON.parse(this.allocationSearch.searchData)
        this.form = JSON.parse(this.allocationSearch.form)
        this.form.skipCount = 0
        this.form.maxResultCount = 10
      }
    }

    this.warehouseSearch()
    this.getStaff()
    this.getPage()
  },
  methods: {
    ...mapActions('warehouse', ['getWarehousesList']),
    ...mapActions('setting', ['getStaffAllData']),
    ...mapActions('order', ['saveAllocationSearch', 'getAllocationsData', 'exportOrderListCsv', 'exportOrderListCsvNew', 'getAllocationDetail', 'exportShipmentExcel', 'changeCSVState']),
    handleGoToDetail(row) {
      this.$router.push({
        name: 'allocationView',
        query: {
          id: row.orderId
        }
      })
    },
    // 点击了某一行
    handleRowClick(row) {
      if (this.$util.tool.hasPerm('OrderManager.AllocationList') && row.canView === true) {
        this.handleGoToDetail(row)
      }
    },
    // 保存搜索条件
    saveSearchData() {
      this.saveAllocationSearch({
        searchData: JSON.stringify(this.searchData),
        form: JSON.stringify(this.form)
      })
    },
    renderTime(param) {
      return format(param.orderConfirmTime, 'YYYY-MM-DD HH:mm')
    },
    getStaff() {
      this.getStaffAllData({ isActive: true, permissionCheck: true }).then(() => {
        this.searchData[1].state = this.staffAllData.items
      })
    },
    /** 获取分页数据 */
    getPage(page) {
      if (typeof page !== 'undefined') {
        this.paginateConfig.page = page
        this.form.skipCount = (page - 1) * this.form.maxResultCount
      }
      if (!this.mx_loaded) this.mx_loading_fn() // 页面加载中
      this.getAllocationsData(this.form).then(() => {
        this.paginateConfig.total = this.alloactionsData.totalCount
        this.mx_loaded_fn() // 页面加载完成
        for (var i = 0; i < this.alloactionsData.items.length; i++) {
          // 未导出状态的订单
          if (this.alloactionsData.items[i].isNotImported === true) {
            // 页面复选框状态
            if (this.selectIds.includes(this.alloactionsData.items[i].orderId)) {
              this.alloactionsData.items[i].isNotImported = false
            }
            // 去重
            if (!this.orderIds.includes(this.alloactionsData.items[i].orderId) &&
                !this.selectIds.includes(this.alloactionsData.items[i].orderId)) {
              this.orderIds.push(this.alloactionsData.items[i].orderId)
            }
          } else { // 已导出状态的订单
            if (this.selectIds.includes(this.alloactionsData.items[i].orderId)) {
              this.alloactionsData.items[i].isNotImported = true
            }
          }
        }
      })
    },
    /** 分页页数改变 */
    handlePageChange(page) {
      this.getPage(page)
    },
    /** 搜索数据表单变化 */
    handleSearchChange(search) {
      delete this.form.isFromDashboard
      this.form = { ...this.form, ...search }
      if (search.daterange) {
        this.form = { ...this.form, ...{ orderStartTime: search.daterange.start }, ...{ orderEndTime: search.daterange.end }}
      }
      if (search.shipped) {
        this.form = { ...this.form, ...{ shippedStartTime: search.shipped.start }, ...{ shippedEndTime: search.shipped.end }}
      }
      if (search.status === null) {
        this.searchData[7].value = []
      }
      delete this.form.daterange
      delete this.form.shipped
      // 保存搜索条件
      this.saveSearchData()
      this.getPage(1)
    },
    // 导出文件
    exportFileCsv() {
      this.exportOrderListCsv(this.form)
        .then(() => {
          this.$store.commit('app/setNotification', {
            msg: this.$t('Views.Goods.actionSuccess'),
            type: 'success'
          })
        })
        .catch(() => {
          this.$store.commit('app/setNotification', {
            msg: this.$t('Views.Order.exportError'),
            type: 'error'
          })
        })
    },
    // 导出文件
    exportFileCsvNew() {
      this.form.orderId = JSON.stringify(this.orderIds) // 导出的时候将页面上勾选的订单赋给表单
      this.form.cancelId = JSON.stringify(this.cancelIds) // 导出的时候将页面上取消勾选的订单赋给表单
      this.exportOrderListCsvNew(this.form)
        .then(() => {
          this.$store.commit('app/setNotification', {
            msg: this.$t('Views.Goods.actionSuccess'),
            type: 'success'
          })
          this.selectIds = []
          this.orderIds = []
          this.cancelIds = []
          this.getPage(1)
        })
        .catch(() => {
          this.$store.commit('app/setNotification', {
            msg: this.$t('Views.Order.exportError'),
            type: 'error'
          })
        })
    },
    exportShipment() {
      this.exportShipmentExcel(this.form)
        .then(() => {
          this.$store.commit('app/setNotification', {
            msg: this.$t('Views.Goods.actionSuccess'),
            type: 'success'
          })
        })
        .catch(() => {
          this.$store.commit('app/setNotification', {
            msg: this.$t('Views.Order.exportError'),
            type: 'error'
          })
        })
    },
    warehouseSearch() {
      this.getWarehousesList({}).then(() => {
        this.searchData[16].state = this.warehouseList.items
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .allocation-num {
  text-decoration: underline;
  cursor: pointer;
}
/deep/ .weijishang {
  //display:inline-block;
  text-align: center;
  color: #ff0000;
  background-color: rgba($color: #ff0000, $alpha: 0.15);
  margin-bottom: 2px;
  padding: 2px 5px;
}
/deep/ .jishang {
  //display:inline-block;
  text-align: center;
  margin-bottom: 2px;
  padding: 2px 5px;
}
.content-wrap {
  padding: 24px;
}
/deep/.isEarlyShipment::after {
  position: relative;
  top: -3px;
  content: '';
  color: black;
  display: inline-block;
  visibility: visible;
  padding-left: 0;
  text-align: center;
  line-height: 17px;
  border-radius: 3px;
}
/deep/.isEarlyShipment:checked::after {
  width: 14px;
  height: 14px;
  background-color: #000;
  color: #fff;
  font-size: 12px;
  content: '✔';
}
.grid-container {
  padding: 0 20px;
  .grid {
    display: flex;
    margin-top: 15px;

    .label,
    .content,
    .colon {
      font-size: 14px;
      display: inline-block;
    }
    .label {
      font-weight: bold;
      flex: none;
      width: 80px;
      color: #515151;
    }
    .colon {
      flex: none;
      font-weight: bold;
      padding-right: 15px;
    }
    .content {
      display: flex;
    }
    .value {
      flex: auto;
    }
  }
}
</style>
